<template>
  <div class="addressform" :class="theme_type">
    <p v-if="update">{{$t('account.edit_address')}}</p>
    <h3 v-else>{{$t('account.add_new_address')}}</h3>
    <div class="row">
      <div class="col-sm-6">
        {{$t('account.first_name')}}
        <input
          type="text"
          v-model="address.first_name"
          id="first_name"
          @blur="required"
        />
        <div v-if="error.first_name" class="error">{{error.first_name[0]}}</div>
      </div>
      <div class="col-sm-6">
        {{$t('account.last_name')}}
        <input
          type="text"
          v-model="address.last_name"
          id="last_name"
          @blur="required"
        />
        <div v-if="error.last_name" class="error">{{error.last_name[0]}}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        {{$t('account.company')}}
        <input type="text" v-model="address.company" />
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        {{$t('account.address1')}}
        <input
          type="text"
          v-model="address.address_1"
          id="address_1"
          @blur="required"
        />
        <div v-if="error.address_1" class="error">{{error.address_1[0]}}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        {{$t('account.address2')}}
        <input type="text" v-model="address.address_2" />
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        {{$t('account.city')}}
        <input type="text" v-model="address.city" id="city" @blur="required" />
        <div v-if="error.city" class="error">{{error.city[0]}}</div>
      </div>
      <div class="col-sm-6">
        {{$t('account.country')}}
        <select
          name
          v-model="address.country"
          id="country"
          @blur="required"
          @change="changecountry"
        >
          <option v-for="item in service" :key="item.code" :value="item.code" v-html="item.name"></option>
        </select>
        <div v-if="error.country" class="error">{{error.country[0]}}</div>
      </div>
    </div>
    <div class="row" v-show="province.length">
      <div class="col-sm-12">
        {{$t('account.province')}}
        <select name id v-model="address.state">
          <option v-for="item in province" :key="item.code" :value="item.code" v-html="item.name"></option>
        </select>
        <div v-if="error.state" class="error">{{error.state[0]}}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        {{$t('account.postcode')}}
        <input type="text" v-model="address.postcode" />
      </div>
      <div class="col-sm-6">
        {{$t('account.phone')}}
        <input type="text" v-model="address.phone" />
      </div>
    </div>
    <div style="padding-bottom:15px">
      <input type="checkbox" class="setdefault" v-model="address.default" />
      {{$t('account.set_default_address')}}
    </div>
    <p v-if="theme_type==='default'">
      <el-button
        v-if="update"
        @click="updateaddress"
        :loading="loading"
      >{{toupdate == 'UPDATE ADDRESS' ? $t('account.edit_address') : toupdate}}</el-button>
      <el-button
        @click="setaddress"
        :loading="loading"
        v-else
      >{{toadd == 'ADD ADDRESS' ? $t('account.add_address') : toadd}}</el-button>
    </p>
    <p v-if="theme_type==='venue'" class="col-12 col-md-3" style="margin-right:10px">
      <el-button
        v-if="update"
        @click="updateaddress"
        :loading="loading"
        class="product_single_add_button"
      >
        <span>{{toupdate == 'UPDATE ADDRESS' ? $t('account.edit_address') : toupdate}}</span>
      </el-button>
      <el-button @click="setaddress" :loading="loading" v-else class="product_single_add_button">
        <span>{{toadd == 'ADD ADDRESS' ? $t('account.add_address') : toadd}}</span>
      </el-button>
    </p>
    <p
      v-if="theme_type==='showtime'"
      class="col-12 col-md-3 showtime_button"
      style="margin-right:10px"
    >
      <button v-if="update" @click="updateaddress" :loading="loading">
        <span>{{toupdate == 'UPDATE ADDRESS' ? $t('account.edit_address') : toupdate}}</span>
      </button>
      <button @click="setaddress" :loading="loading" v-else>
        <span>{{toadd == 'ADD ADDRESS' ? $t('account.add_address') : toadd}}</span>
      </button>
      <span>or</span>
      <a href="#" @click="hiddenform">{{$t('account.cancel')}}</a>
    </p>
    <!-- <p v-if="theme_type!='showtime'" class="col-12 col-md-1 text-center"> -->
    <p v-if="theme_type==='venue'||theme_type==='default'" :class="theme_type==='venue'?'text-md-left text-center col-md-5':''">
      <a href="#" @click="hiddenform">{{$t('account.cancel')}}</a>
    </p>
    <v-line v-if="theme_type==='default'"></v-line>
  </div>
</template>
<script>
import API from "../../../API.js";
export default {
  props: ["update", "service", "address_list", "theme_type"],
  data() {
    return {
      loading: false,
      toupdate: "UPDATE ADDRESS",
      toadd: "ADD ADDRESS",
      province: [],
      address: {
        first_name: "",
        last_name: "",
        company: null,
        city: "",
        country: this.$store.state.country,
        state: null,
        postcode: null,
        address_1: "",
        address_2: null,
        phone: null,
        default: false
      },
      error: {
        address_1: "",
        city: "",
        country: "",
        first_name: "",
        last_name: ""
      }
    };
  },
  methods: {
    required(e) {
      if (e.target.value.trim() == "") {
        switch (e.target.id) {
          case "address_1":
          case "city":
          case "country":
          case "first_name":
          case "last_name":
            this.error[e.target.id] = [this.$t("account.field_required")];
            break;
          default:
            break;
        }
      } else {
        switch (e.target.id) {
          case "address_1":
          case "city":
          case "country":
          case "first_name":
          case "last_name":
            this.error[e.target.id] = "";
            break;
          default:
            break;
        }
      }
    },
    hiddenform() {
      this.$emit("hiddenform");
    },
    changecountry(e) {
      this.address.state = null;
      this.province = this.service[e.target.selectedIndex].states;
      if (this.province.length) {
        this.address.state = this.province[0].code;
      }
    },
    yanzheng() {
      let value = true;
      console.log(this.address_list);
      this.address_list.some(item => {
        console.log("asdfasf", item, this.address);
        if (
          item.first_name == this.address.first_name &&
          item.last_name == this.address.last_name &&
          item.company == this.address.company &&
          item.city == this.address.city &&
          item.country == this.address.country &&
          item.state == this.address.state &&
          item.postcode == this.address.postcode &&
          item.address_1 == this.address.address_1 &&
          item.address_2 == this.address.address_2 &&
          item.phone == this.address.phone &&
          (!this.update || item.default == this.address.default)
        ) {
          if (this.update) {
            let update = JSON.stringify(this.update);
            this.address = JSON.parse(update);
          }
          this.$emit("hiddenform");
          value = false;
          return true;
        }
      });
      let test = ["address_1", "city", "country", "first_name", "last_name"];
      if (this.province.length) {
        test.push("state");
      }
      test.forEach(item => {
        if (this.address[item].trim() == "") {
          this.error[item] = [this.$t("account.field_required")];
          value = false;
        }
      });
      console.log("value", value);
      return value;
    },
    async setaddress() {
      if (this.yanzheng()) {
        try {
          this.loading = true;
          this.toadd = "";
          let res = await this.$axios.post(API.setaddress, this.address);
          if (res.status == 200) {
            window.open("/account/address", "_self");
          }
        } catch (error) {
          this.loading = false;
          this.toadd = "ADD ADDRESS";
          if (error.response.status == 422) {
            this.error = error.response.data.errors;
          } else {
            this.$message.error(error.response.statusText);
          }
        }
      }
    },
    async updateaddress() {
      if (this.yanzheng()) {
        try {
          this.loading = true;
          this.toupdate = "";
          let res = await this.$axios.put(
            API.updateaddress + this.address.id,
            this.address
          );
          if (res.status == 200) {
            window.open("/account/address", "_self");
          }
        } catch (error) {
          this.loading = false;
          this.toupdate = "UPDATE ADDRESS";
          if (error.response.status == 422) {
            console.log(error.response);

            this.error = error.response.data.errors;
          } else {
            this.$message.error(error.response.statusText);
          }
        }
      }
    }
  },
  beforeMount() {
    if (this.update) {
      let update = JSON.stringify(this.update);
      this.address = JSON.parse(update);
    }
    this.service.forEach(item => {
      if (item.code == this.address.country) {
        this.province = item.states;
      }
    });
    if (!this.update) {
      this.address.state = this.province.length ? this.province[0].code : "";
    }
  },
  watch: {
    'address.phone'(newV){
      this.address.phone=newV.replace(/[\D]/g, "");
    },
    "$store.state.country"(newV) {
      this.address.country = newV;
      this.service.forEach(item => {
        if (item.code == newV) {
          this.province = item.states;
        }
      });
    }
  }
};
</script>
<style scoped lang='scss'>
.venue {
  p {
    display: inline-block;
  }
}

.addressform {
  .row {
    margin-bottom: 10px;

    .setdefault {
      vertical-align: middle;
    }

    input,
    select {
      width: 100%;
      padding: 8px 10px;
      background: #f7f7f7;
      border: none;
    }

    .error {
      font-size: 14px;
      color: #e32c2b;
    }
  }

  p {
    font-size: 15px;

    button {
      display: inline-block;
      padding: 12px 20px;
      margin-bottom: 10px;
      color: white;
      background: #c90d0d;
      border: none;
    }

    a {
      text-decoration: none;
      color: black;
    }
  }
}

.showtime {
  h3 {
    font-size: 1.333em;
    color: #2f2f2f;
    font-family: "Times New Roman", Times, serif;
  }

  .row {
    margin-right: -15px;
    margin-left: -15px;

    & {
      div {
        input {
          border: 1px solid #dedede;
          background-color: rgba(133, 133, 133, 0.1);
        }

        select {
          background: #f3f3f3;
          border: 1px solid #dedede;
        }
      }
    }
  }

  .showtime_button {
    button {
      padding: 8px 20px;
      font-size: 12px;
      transition: background-color 0.2s ease-out;
      background-color: #898e88;
      color: #f3f3f3;
      border-radius: 2px;
      font-family: "Lato", sans-serif;
      text-transform: uppercase;
      border: 1px solid transparent;
      font-weight: 400;
      line-height: 1.42;
    }

    button:hover,
    button:focus {
      background-color: #7c827b;
      color: #f3f3f3;
      transition: background-color 0.05s ease-in;
    }

    span {
      margin: 0 15px;
    }

    a {
      color: #898e88;
      text-decoration: none;
      background: transparent;
    }

    a:hover,
    a:focus {
      color: #b0b3af;
    }
  }
}
</style>